import { render } from "./PlayArea.vue?vue&type=template&id=1c41f996&scoped=true"
import script from "./PlayArea.vue?vue&type=script&lang=js"
export * from "./PlayArea.vue?vue&type=script&lang=js"

import "./PlayArea.vue?vue&type=style&index=0&id=1c41f996&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c41f996"]])

export default __exports__